import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import css from "./MenuPacksSingleComponent.module.css";
import { SingleMenuDishComponent } from "../SingleMenuDishComponent/SingleMenuDishComponent";
import { menuMenuActions } from "../../../store/slices/menu-slices";
import NutrientSummary from "../NutrientSummary/NutrientSummary";
import { ChevronDown } from "lucide-react";

const MenuPacksSingleComponent = ({ pack, setIsOpen }) => {
  const dispatch = useDispatch();
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const { id, name, meals, menuDishes, pricePerDay } = pack;

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const displayName = name[currentLanguage] || name["en"];

  const openModal = (mealId, packId, idMatching) => {
    setIsOpen(true);
    dispatch(menuMenuActions.changeId(packId));
    dispatch(menuMenuActions.changeIdForMeal(mealId));

    if (idMatching) {
      dispatch(menuMenuActions.changeIdMatching(idMatching));
      dispatch(menuMenuActions.changeTrigger());
    }
  };

  return (
    <div className={css.wrap}>
      <div
        className={css.header}
        onClick={() => setIsDetailsOpen(!isDetailsOpen)}
      >
        <div className={css.packName}>{displayName}</div>
        <NutrientSummary menuDishes={menuDishes} />

        <div className={css.packPriceContainer}>
          <div className={css.packPrice}>
            <span className={css.packPriceLabel}>Price per day:</span>
            <span className={css.packPriceValue}>{pricePerDay.toFixed(2)}</span>
          </div>
          <div className={css.packCoast}>
            <span className={css.packCoastText}>
              Cost{" "}
              {`(Total ${menuDishes
                .map((dish) => {
                  return (
                    Number(dish.dish.cost) +
                    Number(dish.proteinDish?.cost || 0) +
                    Number(dish.sauceDish?.cost || 0)
                  );
                })
                .reduce((acc, curr) => acc + curr, 0)
                .toFixed(2)})`}
            </span>
          </div>
          <ChevronDown
            className={css.chevron}
            aria-hidden
            style={{
              transform: isDetailsOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </div>
      </div>

      {isDetailsOpen &&
        meals &&
        meals.map((meal) => {
          const mealName = meal.name[currentLanguage] || meal.name["en"];

          const matchingDish = menuDishes.find(
            (item) => item.mealId === meal.id,
          );
          const idMatching = matchingDish ? matchingDish.id : null;

          return (
            <div className={css.container} key={meal.id}>
              <div className={css.info}>
                {matchingDish ? (
                  <SingleMenuDishComponent
                    dish={matchingDish.dish}
                    menuId={matchingDish.id}
                    type={matchingDish.type}
                    proteinDish={matchingDish.proteinDish}
                    sauceDish={matchingDish.sauceDish}
                    mealName={mealName}
                    setIsOpen={setIsOpen}
                    idMatching={idMatching}
                    mealId={meal.id}
                    packId={id}
                  />
                ) : (
                  <div
                    className={css.noData}
                    onClick={() => openModal(meal.id, id, idMatching)}
                  >
                    No data
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default React.memo(MenuPacksSingleComponent);
